import { AnimateStaggeredChildren } from "@storytell/ui/animation";
import { StDropdown, StDropdownItem, StDropdownTrigger } from "@storytell/ui/dropdown";
import { StTooltip, StTooltipTrigger } from "@storytell/ui/tooltip";
import {
  TbCopy,
  TbFile,
  TbFileCode,
  TbFileSpreadsheet,
  TbMicrophone,
  TbPhoto,
  TbSlideshow,
  TbVideo,
} from "solid-icons/tb";
import { type Component, For, Show, createSignal } from "solid-js";
import { Dynamic } from "solid-js/web";
import { useWire } from "~/wire";
import { PromptBarPasteContentCTA } from "./PromptBarPasteContentCTA";

export const PromptBarAssetsCTA: Component<{
  onOpenFilePicker: () => void;
}> = (props) => {
  const wire = useWire();
  return (
    <Show when={wire.grants.canCreate("cp.assets")}>
      <div class="flex items-center justify-center flex-wrap gap-2">
        <IntegrationsCTA />
        <FilesCTA onOpenFilePicker={props.onOpenFilePicker} />
        <PromptBarPasteContentCTA />
        {/* <button */}
        {/*   type="button" */}
        {/*   class="group/btn select-none rounded-full pl-2 pr-3 py-1 flex items-center gap-2 cursor-pointer bg-panel hover:bg-panel-hover border border-primary-border text-primary-text" */}
        {/* > */}
        {/*   <span class="rounded-full bg-tile size-7 grid place-content-center border border-muted-border group-hover/btn:scale-hover group-active/btn:scale-active transition-transform"> */}
        {/*     <TbCopy class="size-5" /> */}
        {/*   </span> */}
        {/**/}
        {/*   <span>Paste</span> */}
        {/* </button> */}
      </div>
    </Show>
  );
};

const IntegrationsCTA = () => {
  const [integrationsOpen, setIntegrationsOpen] = createSignal(false);
  const integrations = [
    { label: "Google Drive", icon: GoogleDriveIcon },
    { label: "Zoom", icon: ZoomIcon },
  ];
  return (
    <StDropdown
      placement="bottom-start"
      modal={false}
      preventScroll={false}
      gutter={5}
      open={integrationsOpen()}
      onOpenChange={setIntegrationsOpen}
      contentProps={{
        class: "px-1 z-10",
      }}
      content={
        <div class="flex flex-col">
          <p class="text-muted-text py-1 px-2">Coming Soon:</p>
          <For each={integrations}>
            {(integration) => (
              <StDropdownItem
                disabled
                class="cursor-pointer flex items-center gap-3 hover:bg-canvas-hover rounded-md px-2 py-2"
              >
                <Dynamic component={integration.icon} class="size-5" />
                {integration.label}
              </StDropdownItem>
            )}
          </For>

          <div class="h-[1px] bg-muted-border my-2" />

          <StDropdownItem
            as="a"
            href="https://go.Storytell.ai/MCP"
            target="_blank"
            rel="noopener noreferrer"
            class="cursor-pointer underline text-brand flex items-center gap-3 hover:bg-canvas-hover rounded-md px-2 py-2"
          >
            + Connect via MCP Server
          </StDropdownItem>

          <div class="h-[1px] bg-muted-border my-2" />

          <StDropdownItem
            as="a"
            href="https://roadmap.storytell.ai/?b=6849bab613211c71c117af0e&sortBy=upvotes%3Adesc"
            target="_blank"
            rel="noopener noreferrer"
            class="cursor-pointer underline text-brand flex items-center gap-3 hover:bg-canvas-hover rounded-md px-2 py-2"
          >
            Request More Integrations
          </StDropdownItem>
        </div>
      }
    >
      <StDropdownTrigger class="group/btn select-none rounded-full pl-2 pr-3 py-1 flex items-center gap-2 cursor-pointer bg-panel hover:bg-panel-hover border border-primary-border text-primary-text">
        <span class="flex items-center">
          <span class="rounded-full bg-tile group-hover/btn:bg-tile-hover size-7 grid place-content-center border border-muted-border group-hover/btn:scale-hover group-active/btn:scale-active transition-transform">
            <GoogleDriveIcon class="size-5" />
          </span>
          <span class="-ml-[0.5rem] rounded-full bg-tile group-hover/btn:bg-tile-hover size-7 grid place-content-center border border-muted-border group-hover/btn:scale-hover group-active/btn:scale-active transition-all">
            <ZoomIcon class="size-5" />
          </span>
        </span>
        <span>Integrations</span>
      </StDropdownTrigger>
    </StDropdown>
  );
};

const ZoomIcon = (props: { class?: string }) => (
  <svg
    class={props.class}
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 48 48"
  >
    <defs>
      <linearGradient
        id="zoom-linear-gradient"
        x1="11.3597"
        y1="45.89364"
        x2="36.6403"
        y2="2.10636"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#0845bf" />
        <stop offset=".6" stop-color="#0b5cff" />
        <stop offset="1" stop-color="#4f90ee" />
      </linearGradient>
    </defs>
    <g>
      <path
        id="container"
        style={{
          fill: "url(#zoom-linear-gradient)",
          "stroke-width": "0",
        }}
        d="m48,24c0,2.56649-.20631,5.08306-.60043,7.53687-1.30472,8.12336-7.73942,14.55801-15.86279,15.8627-2.45387.39412-4.97047.60043-7.53678.60043s-5.08291-.20631-7.53678-.60043c-8.12337-1.30469-14.55806-7.73934-15.86279-15.8627C.20631,29.08306,0,26.56649,0,24s.20631-5.08306.60043-7.53687C1.90515,8.33977,8.33985,1.90512,16.46322.60043,18.91709.20631,21.43368,0,24,0s5.08291.20631,7.53678.60043c8.12337,1.30469,14.55806,7.73934,15.86279,15.8627.39411,2.45381.60043,4.97038.60043,7.53687Z"
      />
      <path
        id="ZM"
        class="fill-white"
        d="m20.407,31.33266h-11.8779c-.83337,0-1.57795-.49753-1.89686-1.26746-.31891-.76993-.14418-1.64827.44512-2.23746l8.22737-8.22733h-5.89671c-1.61989,0-2.93306-1.31317-2.93306-2.93306h10.95403c.8333,0,1.57785.49739,1.89679,1.26732.31898.76993.14436,1.64813-.44486,2.23761l-8.2274,8.22733h6.82044c1.61989,0,2.93306,1.31317,2.93306,2.93306Zm21.11806-9.16583c0-3.15376-2.56575-5.71948-5.71948-5.71948-1.68694,0-3.20517.73455-4.25294,1.90012-1.04777-1.16556-2.566-1.90012-4.25294-1.90012-3.15372,0-5.71948,2.56572-5.71948,5.71948v9.16583c1.61988,0,2.93306-1.31318,2.93306-2.93306v-6.23276c0-1.53642,1.24999-2.78641,2.78641-2.78641s2.78641,1.24999,2.78641,2.78641v6.23276c0,1.61989,1.31318,2.93306,2.93306,2.93306v-9.16583c0-1.53642,1.24999-2.78641,2.78641-2.78641s2.78641,1.24999,2.78641,2.78641v6.23276c0,1.61989,1.31318,2.93306,2.93306,2.93306v-9.16583Z"
      />
    </g>
  </svg>
);

const GoogleDriveIcon = (props: { class?: string }) => (
  <svg class={props.class} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path
      fill="#1e88e5"
      d="M38.59,39c-0.535,0.93-0.298,1.68-1.195,2.197C36.498,41.715,35.465,42,34.39,42H13.61 c-1.074,0-2.106-0.285-3.004-0.802C9.708,40.681,9.945,39.93,9.41,39l7.67-9h13.84L38.59,39z"
    />
    <path
      fill="#fbc02d"
      d="M27.463,6.999c1.073-0.002,2.104-0.716,3.001-0.198c0.897,0.519,1.66,1.27,2.197,2.201l10.39,17.996 c0.537,0.93,0.807,1.967,0.808,3.002c0.001,1.037-1.267,2.073-1.806,3.001l-11.127-3.005l-6.924-11.993L27.463,6.999z"
    />
    <path
      fill="#e53935"
      d="M43.86,30c0,1.04-0.27,2.07-0.81,3l-3.67,6.35c-0.53,0.78-1.21,1.4-1.99,1.85L30.92,30H43.86z"
    />
    <path
      fill="#4caf50"
      d="M5.947,33.001c-0.538-0.928-1.806-1.964-1.806-3c0.001-1.036,0.27-2.073,0.808-3.004l10.39-17.996 c0.537-0.93,1.3-1.682,2.196-2.2c0.897-0.519,1.929,0.195,3.002,0.197l3.459,11.009l-6.922,11.989L5.947,33.001z"
    />
    <path
      fill="#1565c0"
      d="M17.08,30l-6.47,11.2c-0.78-0.45-1.46-1.07-1.99-1.85L4.95,33c-0.54-0.93-0.81-1.96-0.81-3H17.08z"
    />
    <path
      fill="#2e7d32"
      d="M30.46,6.8L24,18L17.53,6.8c0.78-0.45,1.66-0.73,2.6-0.79L27.46,6C28.54,6,29.57,6.28,30.46,6.8z"
    />
  </svg>
);

const FilesCTA = (props: { onOpenFilePicker: () => void }) => {
  const [open, setOpen] = createSignal(false);
  const assets = [
    { label: "Docs", icon: TbFile },
    { label: "Slides", icon: TbSlideshow },
    { label: "Spreadsheets", icon: TbFileSpreadsheet },
    { label: "Code", icon: TbFileCode },
    { label: "Images", icon: TbPhoto },
    { label: "Audio", icon: TbMicrophone },
    { label: "Video", icon: TbVideo },
  ];

  return (
    <StTooltip
      contentProps={{
        class: "z-10",
      }}
      placement="top"
      dontKeepOpenOnHover
      open={open()}
      onOpenChange={setOpen}
      content={<div>Click to upload or drag files anywhere on the page</div>}
    >
      <StTooltipTrigger
        keepOpenOnClick
        onClick={props.onOpenFilePicker}
        class="group/btn select-none rounded-full pl-2 pr-3 py-1 flex items-center gap-2 cursor-pointer bg-panel hover:bg-panel-hover border border-primary-border text-primary-text h-[2.375rem] transition-all"
        classList={{
          "w-[11rem]": !open(),
          "w-[34.125rem]": open(),
        }}
      >
        <span class="flex items-center gap-2" classList={{ hidden: open() }}>
          <span class="flex items-center">
            <span class="rounded-full bg-tile size-7 grid place-content-center border border-muted-border">
              <TbFileSpreadsheet class="size-5" />
            </span>
            <span class="-ml-[0.5rem] rounded-full bg-tile size-7 grid place-content-center border border-muted-border">
              <TbSlideshow class="size-5" />
            </span>
          </span>
          <span>Upload Files</span>
        </span>

        <Show when={open()}>
          <AnimateStaggeredChildren
            show={true}
            enter={{
              opacity: [0, 1],
              y: [-5, 0],
            }}
            stagger={60}
            exit={{
              opacity: [1, 0],
              y: [0, -5],
            }}
          >
            {(anim) => (
              <span class="flex items-center gap-3 text-sm cursor-pointer" onClick={props.onOpenFilePicker}>
                <For each={assets}>
                  {(asset) => (
                    <span class="flex items-center gap-1" ref={anim.ref}>
                      <Dynamic component={asset.icon} class="size-4" />
                      {asset.label}
                    </span>
                  )}
                </For>
              </span>
            )}
          </AnimateStaggeredChildren>
        </Show>
      </StTooltipTrigger>
    </StTooltip>
  );
};
